import React from 'react';
import { GoogleDominationMockup } from '../growth/GoogleDominationMockup';
import { AdsDashboardMockup } from '../growth/AdsDashboardMockup';
import { GoogleMediaSection } from '../growth/GoogleMediaSection';
import { Sparkles, TrendingUp, ShieldCheck, Zap, ArrowRight, Award } from 'lucide-react';

export const GrowthMachineSection: React.FC = () => {
  return (
    <section id="growth-machine" className="w-full bg-[#121212] text-white py-28 px-4 md:px-12 font-sans relative overflow-hidden transition-colors duration-700">
      
      {/* Background Soft Glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#FFD700]/5 blur-[120px] pointer-events-none rounded-full" />

      <div className="max-w-7xl mx-auto space-y-20 relative z-10">
         
         {/* FLAGSHIP UPGRADE HEADER */}
         <div className="text-center max-w-3xl mx-auto space-y-6">
            <div className="inline-flex items-center gap-2 bg-[#FFD700]/10 text-[#FFD700] px-4 py-1.5 rounded-full text-xs font-bold border border-[#FFD700]/20 shadow-sm">
               <Sparkles className="w-3.5 h-3.5" />
               UPGRADE PREMIUM • GESTÃO DE TRÁFEGO & PRESENÇA 360°
            </div>
            
            <h2 className="text-4xl md:text-6xl font-heading font-black tracking-tight text-white leading-tight">
               Growth <span className="text-[#FFD700] underline decoration-[#FFD700]/40 underline-offset-8">MACHINE</span>
            </h2>

            <p className="text-slate-400 text-base md:text-lg font-light leading-relaxed">
               O acelerador de crescimento para empresas que buscam dominância total da região. Posicionamento #1 no Google, tráfego pago otimizado por IA e autoridade de marca 24/7.
            </p>
         </div>

         {/* HIGHLIGHT KPI BENTO CARDS */}
         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            
            {/* KPI 1 */}
            <div className="bg-[#1A1A1A] border border-neutral-800 rounded-[24px] p-6 text-left space-y-3 hover:border-neutral-700 transition-all">
               <div className="flex justify-between items-center">
                  <span className="text-xs font-bold text-neutral-400 uppercase tracking-wider">Busca Orgânica & Ads</span>
                  <Award className="w-4 h-4 text-[#FFD700]" />
               </div>
               <strong className="text-3xl font-black text-white block">Google Rank #1</strong>
               <p className="text-xs text-neutral-400">Primeira posição assegurada para as palavras-chave com maior intenção de compra da cidade.</p>
            </div>

            {/* KPI 2 */}
            <div className="bg-[#1A1A1A] border border-neutral-800 rounded-[24px] p-6 text-left space-y-3 hover:border-neutral-700 transition-all">
               <div className="flex justify-between items-center">
                  <span className="text-xs font-bold text-neutral-400 uppercase tracking-wider">Retorno Médio de Campanha</span>
                  <TrendingUp className="w-4 h-4 text-emerald-400" />
               </div>
               <strong className="text-3xl font-black text-emerald-400 block">ROAS 8.5x</strong>
               <p className="text-xs text-neutral-400">Gestão contínua de campanhas no Meta Ads (Instagram/Facebook) e Google Ads com inteligência de público.</p>
            </div>

            {/* KPI 3 */}
            <div className="bg-[#1A1A1A] border border-neutral-800 rounded-[24px] p-6 text-left space-y-3 hover:border-neutral-700 transition-all">
               <div className="flex justify-between items-center">
                  <span className="text-xs font-bold text-neutral-400 uppercase tracking-wider">Atração de Clientes</span>
                  <Zap className="w-4 h-4 text-[#FFD700]" />
               </div>
               <strong className="text-3xl font-black text-white block">Atração 24/7</strong>
               <p className="text-xs text-neutral-400">Seu negócio captando novos contatos e pedidos no piloto automático, mesmo fora do horário comercial.</p>
            </div>

         </div>

         {/* GOOGLE DOMINATION MOCKUP SECTION (ORGANIC & GMN) */}
         <div className="rounded-[24px] overflow-hidden border border-neutral-800">
            <GoogleDominationMockup />
         </div>

         {/* GOOGLE MEDIA & SOCIAL DISPLAY */}
         <div className="rounded-[24px] overflow-hidden border border-neutral-800">
            <GoogleMediaSection />
         </div>

         {/* ADS DASHBOARD DISPLAY */}
         <div className="rounded-[24px] overflow-hidden border border-neutral-800">
            <AdsDashboardMockup />
         </div>

         {/* BOTTOM CTA: GROWTH MACHINE PREMIUM */}
         <div className="bg-[#1A1A1A] border border-neutral-800 rounded-[24px] p-10 text-center space-y-6 max-w-4xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-heading font-black text-white">
               Transforme sua empresa em uma <span className="text-[#FFD700]">máquina de vendas</span>
            </h3>
            <p className="text-slate-400 text-sm md:text-base max-w-xl mx-auto font-light">
               Pacote completo Growth Machine a partir de R$ 990,00 nos primeiros 6 meses. Consultoria e implantação técnica inclusas.
            </p>
            <div className="pt-2">
               <button className="bg-[#FFD700] hover:bg-amber-400 text-slate-950 font-black text-base px-8 py-4 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-amber-500/10">
                  Solicitar Proposta Growth Machine Premium
               </button>
            </div>
         </div>

      </div>
    </section>
  );
};
